import React, { useState } from 'react';
import { ModalWrapper } from './ModalWrapper';

interface Parent2SignModalProps {
    isOpen: boolean;
    onClose: () => void;
    signLink: string;
}

export const Parent2SignModal: React.FC<Parent2SignModalProps> = ({
    isOpen,
    onClose,
    signLink
}) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(signLink);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <ModalWrapper modalId="Parent2SignModal"
            isOpen={isOpen}
            onClose={onClose}
            title="Parent 2 Sign"
        >
            {/* Link with Copy Button */}
            <div className="flex items-center gap-3 bg-[#EBF5F5] rounded-lg p-4">
                <a
                    href={signLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#366A75] hover:text-[#2D5A60] underline text-lg font-medium"
                >
                    Sign
                </a>
                <button
                    onClick={handleCopy}
                    className="p-2 hover:bg-[#D0E7E5] rounded transition-colors"
                    title="Copy to clipboard"
                >
                    {copied ? (
                        <span className="text-green-600 text-xl">✓</span>
                    ) : (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-[#366A75]"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                            />
                        </svg>
                    )}
                </button>
            </div>
        </ModalWrapper>
    );
};
